import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Image, Text } from "@mantine/core";
import { AuthLayout } from 'src/components/Layout/AuthLayout';
import { VisualSideLayout } from 'src/components/Layout/VisualsLayout';
import { UserTypeToggle } from 'src/components/Toggles/UserTypeToggle';
import { LearnerSignInForm } from 'src/components/Forms/LearnerSignin';
import { ParentSignInForm } from 'src/components/Forms/ParentSignin';
import { authService } from "src/services/services/auth/auth.api";
import { ResponseKind } from "src/services/services/MainService";
import { ErrorKind } from "src/services/services/MainService/apiProblem";
import { clearToken, setRole, setToken } from 'src/utils/storage';
import { useAppDispatch } from 'src/redux/redux-store/hooks';
import { updateAdminSettings, updateAppSettings, updateUser } from 'src/redux/redux-store';
import { UserRole } from 'src/enums/User';
import { userRoutes } from 'src/navigators/routes/user';
import { useAuth } from 'src/hooks/useAuth';
import { authRoutes } from 'src/navigators/routes/auth';
import { AuthHeader } from 'src/components/common/Cards/AuthHeaderCard';
import { AdminSignInForm } from 'src/components/Forms/AdminSignin';
import { clearStorageToken } from 'src/utils/auth.storage';

const SignIn: React.FC = () => {
  const [userType, setUserType] = useState<'Learner' | 'Parent'>('Learner');
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const {login} = useAuth()


  const loginAsAdmin = useCallback(async (values: any) => {
    setLoading(true);
    try {
      const response = await authService.logIn(
        values.email,
        values.password
      );
      console.log("Token data" , response)
      if (response.kind === ResponseKind.OK) {
        const tokenData = response.data;
        console.log("Token data" ,tokenData)
        if (tokenData) {
          if (tokenData.role === UserRole.admin) {
            login(tokenData)
            navigate('/admin');
          } else {
            clearStorageToken()
            alert("Invalid credentials");
            return;
          }
        } else {
          alert("Invalid credentials");
        }
      } else {
        throw new Error("Login failed");
      }
    } catch (e) {
      alert("Invalid credentials");
    } finally {
      setLoading(false);
    }
  }, []);


  const formComponent = (
    <div className="w-full max-w-md space-y-6">
      <AuthHeader title='Sign In' subtitle='Enter your details to sign in' />
      <AdminSignInForm onSubmit={loginAsAdmin} loading={loading}/>

    </div>
  );

  return (
    <AuthLayout
      visualComponent={<VisualSideLayout/>}
      formComponent={formComponent}
    />
  );
};

export default SignIn;


